import React from 'react';

/**
 * @param {object} props
 * @return {*}
 * @constructor
 */
export default ({ htmlFor, className, label, children }) => (
    <label
        htmlFor={htmlFor}
        className={`block text-sm font-medium leading-5 text-gray-700 mb-1 ${className}`}
    >
        {children ?? label}
    </label>
);
